// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"7b3eedd8","538":"58718903","545":"363a01e3","566":"8ac7cd68","614":"084c75c7","676":"ae0cdd2d","882":"a605a272"}[chunkId] + ".chunk.js";
};